import React, { useEffect, useMemo, useState } from "react";
import {
  Col, Row, Card, CardBody, Badge, Button, Spinner, Alert
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const UzmanDegerlendirmeleri = () => {
  document.title = "Uzman Değerlendirmeleri | HarmanaGEL";

  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}` };

  const [liste, setListe] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");

  const fetchListe = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const res = await fetch(
        `${BASE_URL}/UZMAN_DEGERLENDIRMELERI?$orderby=ID desc&$expand=ILANLAR($select=AD),KULLANICILAR($select=AD_SOYAD),KULLANICILAR1($select=AD_SOYAD)`,
        { headers }
      );
      const result = await res.json();
      setListe(result.value || []);
    } catch {
      setError("Değerlendirmeler yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { fetchListe(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Bu değerlendirmeyi silmek istediğinize emin misiniz?")) return;
    try {
      await fetch(`${BASE_URL}/UZMAN_DEGERLENDIRMELERI(${id})`, { method: "DELETE", headers });
      setSuccessMsg("Değerlendirme silindi.");
      fetchListe();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch {
      setError("Silme sırasında hata oluştu.");
    }
  };

  const columns = useMemo(() => [
    {
      header: "#",
      accessorKey: "ID",
      enableSorting: true,
      cell: (c) => <strong>#{c.getValue()}</strong>,
    },
    {
      header: "İlan",
      accessorKey: "ILAN_ID",
      enableSorting: true,
      cell: (c) => {
        const row = c.row.original;
        return (
          <div>
            <div className="fw-medium">{row.ILANLAR?.AD || "—"}</div>
            <small className="text-muted">İlan #{c.getValue()}</small>
          </div>
        );
      },
    },
    {
      header: "Değerleme Yapan (Uzman)",
      accessorKey: "DEGERLEME_YAPAN_ID",
      enableSorting: false,
      cell: (c) => {
        const row = c.row.original;
        return <div><div>{row.KULLANICILAR?.AD_SOYAD || "—"}</div><small className="text-muted">#{c.getValue()}</small></div>;
      },
    },
    {
      header: "Değerlendiren",
      accessorKey: "DEGERLENDIREN_ID",
      enableSorting: false,
      cell: (c) => {
        const row = c.row.original;
        return <div><div>{row.KULLANICILAR1?.AD_SOYAD || "—"}</div><small className="text-muted">#{c.getValue()}</small></div>;
      },
    },
    {
      header: "Puan",
      accessorKey: "PUAN",
      enableSorting: true,
      cell: (c) => <Badge color="warning" className="text-dark"><i className="bx bxs-star" /> {c.getValue() ?? 0}</Badge>,
    },
    {
      header: "Yorum",
      accessorKey: "YORUM",
      enableSorting: false,
      cell: (c) => {
        const v = c.getValue() || "";
        return <span className="text-muted">{v.length > 80 ? v.slice(0, 80) + "…" : (v || "---")}</span>;
      },
    },
    {
      header: "İşlemler",
      enableSorting: false,
      cell: (cellProps) => (
        <Button color="danger" size="sm" outline onClick={() => handleDelete(cellProps.row.original.ID)}>
          <i className="bx bx-trash" />
        </Button>
      ),
    },
  ], []);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Kullanıcılar" breadcrumbItem="Uzman Değerlendirmeleri" />

          {successMsg && <Alert color="success">{successMsg}</Alert>}
          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="mb-3">
                    <h4 className="card-title mb-1">Uzman Değerlendirmeleri</h4>
                    <p className="text-muted small mb-0">
                      Uzmanların ilanlara verdiği değerlendirmeleri görüntüleyin ve uygunsuz olanları kaldırın.
                    </p>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={liste}
                      isGlobalFilter={true}
                      isPagination={true}
                      customPageSize={15}
                      SearchPlaceholder="Değerlendirme ara..."
                      tableClass="align-middle table-nowrap table-hover"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                      pagination="pagination pagination-rounded justify-content-end mb-2"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UzmanDegerlendirmeleri;
